
      export const versions = {
        commit: 'fbd50e87c5e0177db60129df73b7e85141f06656',
        branch: 'HEAD'
      };
